import React from 'react';

const Home = () => {
    return (
        <div className="bg-[url('https://i.ibb.co/KN3MDVc/home-img.jpg')] bg-cover p-0 m-0">
            <div className="h-96 w-full">
                <div className="w-3/6 py-7">
                <h3 className="text-3xl md:text-7xl  font-bold py-10 text-white">Make Your Coffee</h3>
                <h3 className="text-xl md:text-4xl text-white">On Your Own Style</h3>
                </div>
                <div className="w-3/6">

                </div>
            </div>
        </div>
    );
};

export default Home;